<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :isConfirm="isConfirm"
    :width="width"
    :class="{ hideButton: true }"
  >
    <div slot="content">
      <el-form
        label-width="130px"
        ref="form"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="姓名：">{{
          dataForm.Name
        }}</el-form-item>
        <el-form-item label="捐献者电话：">{{
          dataForm.Phone
        }}</el-form-item>
        <el-form-item label="身份证号码：">{{
          dataForm.IdentityCard
        }}</el-form-item>
        <el-form-item label="登记地：">
          <v-region
            :town="true"
            v-model="addre"
            type="text"
            @values="regionChange"
          ></v-region>
        </el-form-item>
        <el-form-item label="捐献意愿：">
          {{ dataForm.Willingness }}
        </el-form-item>
        <el-form-item label="登记时间:">
          {{ (dataForm.CreateTime * 1000) | formatDate }}
        </el-form-item>
        <el-form-item label="OPO/获取单位：">{{
          dataForm.Opo
        }}</el-form-item>
        <el-form-item label="救助人数：">{{
          dataForm.RescueNum
        }}</el-form-item>
        <el-form-item label="器官例数：">{{
          dataForm.OrganCases
        }}</el-form-item>
        <el-form-item label="动员及摘取医院：">{{
          dataForm.ExtractHospital
        }}</el-form-item>
        <el-form-item label="状态：">
          {{ showStatus(dataForm.Status) }}
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {}, //表单校验
      formTitle: "人体器官捐献登记信息", //标题
      isConfirm: false,
      width: "50%", //弹窗宽度
      dataForm: {}, //表单数据
      status: [
        { value: 0, label: "未完成" },
        { value: 1, label: "已完成" },
      ], //状态
  //地址
    };
  },
  components: {
    OfDialog,
  },
  computed: {
    showStatus() {
      return (data) => {
        return data == 0 ? "未完成" : "已完成";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.id };
      api.QueryDonationOrganById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          let addrArry = that.dataForm.RegisterAddress.split(",");
          that.addre = {
            province: addrArry[0],
            city: addrArry[1],
            area: addrArry[2],
            // town: addrArry[3],
            town: ''
          };
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //地址选择
    regionChange(data) {
      let that = this;
      let province = data.province !== null ? data.province.key : "";
      let city = data.city !== null ? data.city.key : "";
      let area = data.area !== null ? data.area.key : "";
      // let town = data.town !== null ? data.town.key : "";
      that.dataForm.RegisterAddress =
        province + "," + city + "," + area
    },
  },
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
</style>

<style>
.hideButton .dialog-footer >>> .el-button--primary {
  display: none;
}
</style>